import { database } from "../index";
import { BUSINESS_SCHEMA, CUSTOMER_SCHEMA, POS_TXNS_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";

const transaction = database.collections.get(POS_TXNS_SCHEMA);

export const getPosTxnsByCustomer = async (id) =>
  await transaction.query(Q.on(CUSTOMER_SCHEMA, "id", id)).fetch();

export const observeGetTransactionByID = (id) =>
  transaction.query(Q.where("id", id)).observe();

export const bulkDeletePosTxns = async (customer_id) => {
  await database.write(async () => {
    let posTxns = await getPosTxnsByCustomer(customer_id);
    const allRecords = await prepareDeletion(posTxns);
    await database.batch(...allRecords);
  });
};
const prepareDeletion = async (posTxns) => {
  return await Promise.all(
    posTxns.map(async (txns) => {
      try {
        return txns.prepareMarkAsDeleted();
      } catch (err) {
      }
    }),
  );
};

export const removeCustomerFromPosTxns = async (customer_id) => {
  await database.write(async () => {
    let posTxns = await getPosTxnsByCustomer(customer_id);
    if (posTxns?.length) {
      const allRecords = await prepareUpdation(posTxns);
      await database.batch(...allRecords);
    }
  });
};

const prepareUpdation = async (pos_txns) => {
  return await Promise.all(
    pos_txns.map(async (txn) => {
      try {
        return txn.prepareUpdate((tx) => {
          tx.customer.set("");
        });
      } catch (err) {
      }
    }),
  );
};
export const getAllTransactionCount = async () =>
  await transaction.query().fetchCount();

export const getAllTransaction = async (id) =>
  await transaction
    .query(
      Q.or(Q.where("trnsId", null), Q.where("trnsId", "")),
      Q.on(BUSINESS_SCHEMA, "id", id),
    )
    .fetch();

export const observerAllTransactionByBusiness = (id) =>
  transaction.query(Q.on(BUSINESS_SCHEMA, "id", id)).observe();

export const observerAllTransactionByBusinessCount = (id) =>
  transaction.query(Q.on(BUSINESS_SCHEMA, "id", id)).observeCount();

export const bulkUpdateOrderId = async (id) => {
  return await database.write(async () => {
    let txnsList = await getAllTransaction(id);
    if (txnsList.length > 0) {
      const allRecords = await prepareUpdationTransId(txnsList);
      await database.batch(...allRecords);
      return txnsList;
    } else return [];
  });
};

const prepareUpdationTransId = async (txnsList) => {
  return txnsList.map((txns) => {
    try {
      return txns.prepareUpdate((trn) => {
        trn.trnsId = trn.id.split("-")[0];
      });
    } catch (err) {
    }
  });
};
